import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import { useProductDetailStore } from '@apps/main/new-desktop/core/stores/productDetail/productDetailStore';

import type { IngredientId } from '@libs/trip-planner-interfaces';
import { ProductSearchType } from '@libs/trip-planner-interfaces';

import type {
  ActivitySelectionActivityDetailsPanel,
  ActivitySelectionPanel,
} from '../models';
import {
  ACTIVITY_SELECTION_NO_PANEL,
  ActivitySelectionPanelType,
} from '../models';

export const useActivitySelectionPanelsStore = defineStore(
  'ActivitySelectionPanelsStore',
  () => {
    const productDetailStore = useProductDetailStore();

    // State
    const activitySelectionPanel = ref<ActivitySelectionPanel>(
      ACTIVITY_SELECTION_NO_PANEL
    );

    // Actions
    function openActivityDetailsPanel(
      productCode: string,
      ingredientId: IngredientId
    ): void {
      const activityDetailsPanel: ActivitySelectionActivityDetailsPanel = {
        type: ActivitySelectionPanelType.ActivityDetails,
        hotelCode: productCode,
        ingredientId,
      };
      activitySelectionPanel.value = activityDetailsPanel;
      productDetailStore.selectDestinationProduct(
        productCode,
        ingredientId,
        ProductSearchType.Activity
      );
    }

    function closeActivityDetailsPanel(): void {
      activitySelectionPanel.value = ACTIVITY_SELECTION_NO_PANEL;
      productDetailStore.clearProductDetails();
    }

    // Getters
    const activitySelectionPanelType = computed<ActivitySelectionPanelType>(
      () => activitySelectionPanel.value.type
    );

    return {
      // Actions
      openActivityDetailsPanel,
      closeActivityDetailsPanel,
      // Getters
      activitySelectionPanelType,
    };
  }
);
